import { NgModule } from '@angular/core';
import { InputSearchComponent } from './input-search.component';

const MODULES = [InputSearchComponent];

@NgModule({
  imports: [...MODULES],
  exports: [...MODULES]
})
export class InputSearchModule {}
